document.addEventListener('DOMContentLoaded', function documentLoad() {
	function loadMorePosts() {
		document.getElementById('loadmore-button').style.display = 'none';
		document.getElementById('loadmore-loader').style.display = 'initial';
		const page = document.getElementById('pagination-page').value;
		const offset = document.getElementById('pagination-offset').value;
		const maxPages = document.getElementById('max_page').value;
		const postType = document.getElementById('post_type').value;
		const excludedPostId = document.getElementById('excluded_post_id').value;
		const categoryid = document.getElementById('categoryid').value;
		const totalCategory = document.getElementById('totalCategory').value;
		let orderBy = '';
		if (document.getElementById('order_by')) {
			orderBy = document.getElementById('order_by').value;
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response===0) {//eslint-disable-line
					document.getElementById('loadmore-loader').style.display = 'none';
				}else{//eslint-disable-line
					document.getElementById('loadmore-button').style.display = 'initial';
					document.getElementById('loadmore-loader').style.display = 'none';
					document
						.querySelector('.loadmore-container')
						.insertAdjacentHTML('beforeend', response.html);
					document.getElementById('pagination-page').value = response.page;
					document.getElementById('pagination-offset').value = response.offset;
					  if(response.postcount >= totalCategory && totalCategory !=''){ //eslint-disable-line
						document.getElementById('loadmore-button').style.display = 'none';
					}
					if (parseInt(page, 0) + 1 > parseInt(maxPages, 0)) {
						document.getElementById('loadmore-button').style.display = 'none';
					}
				}
			}
		};

        const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=load_more_posts&page=${page}&offset=${offset}&post_type=${postType}&categoryid=${categoryid}&order_by=${orderBy}&posts_per_page=10&nonce=${ajaxNonce}&excludedPostId=${excludedPostId}`,
		);
	}

	const loadMoreButton = document.getElementById('loadmore-button');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function (e) {
			e.preventDefault();
			loadMorePosts();
		});
	}

	const tagsWrappers = document.querySelectorAll('.tags-wrapper');
	tagsWrappers.forEach(function (tagsWrapper) {
		if (tagsWrapper.children[0].children.length === 0) {
			tagsWrapper.children[0].remove();
		}
	});
});
